import $ from 'jquery';

const defaults = {};

function SelectAlpha(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.init();
}

SelectAlpha.prototype = {
  init() {
    // const $options = this.$element.find('option');
    const tA = [];
    const selectedId = this.$element.find('option:selected').index();
    for (let i = 0; i < this.$element.find('option').length; i += 1) {
      tA[i] = [];
      tA[i][0] = this.$element.find('option')[i].text;
      tA[i][1] = this.$element.find('option')[i].value;
      tA[i][2] = selectedId === i;
    }
    tA.sort();
    // while (this.$element.find('option').length > 0) {
    //   this.$element.find('option')[0] = null;
    // }
    this.$element.html('');
    for (let i = 0; i < tA.length; i += 1) {
      const $txt = tA[i][0];
      const $val = tA[i][1];
      const op = tA[i][2] ? new Option($txt, $val, false, true) : new Option($txt, $val);
      this.$element.append(op);
    }
  },
};

export default SelectAlpha;
